/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { LayoutContext } from "App/common/hoc/Layout";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import BreadCrumbs from "./BreadCrumb";
import TransLoader from "App/common/ui/TransLoader";
import CreateNewFolder from "./CreateNewFolder";
import EmptyFolder from "./EmptyFolder";
import { enumFolder, selectCustomPath } from "store/actions";
import { ReactComponent as HardDiskIcon } from "assets/images/app_svg/hard_disk.svg";
import { ReactComponent as FolderIcon } from "assets/images/app_svg/folder.svg";
import { decodeHandler, encodeHandler } from "utils";
import { RESTORE_PATH_EXCEPTIONS } from "consts";

function CustomLocationBody(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const [invalidRestorePath, setInvalidRestorePath] = useState(false);

  useEffect(() => {
    props.enumFolder({
      clientUUID: props.fileRestore.targetMachine.clientUUID,
      path:
        props.fileRestore.enumFolder && props.fileRestore.enumFolder.customPath
          ? props.fileRestore.enumFolder.customPath
          : "alldrives"
    });
  }, []);

  useEffect(() => {
    if (props.fileRestore.targetMachine) {
      if (props.fileRestore.checkedList) {
        for (let key in props.fileRestore.checkedList) {
          let exceptionPath =
            props.FRTargetMachine &&
            props.fileRestore.currentRequest.clientUUID ===
              props.FRTargetMachine.clientUUID
              ? RESTORE_PATH_EXCEPTIONS.ownMachine
              : RESTORE_PATH_EXCEPTIONS.otherMachine;

          let folderName = decodeHandler(
            props.fileRestore.checkedList[key].path +
              props.fileRestore.checkedList[key].name
          );

          if (
            exceptionPath.includes(
              folderName
                .split("\\")
                .slice(0, 2)
                .join("\\")
            ) ||
            exceptionPath.includes(
              folderName
                .split("\\")
                .slice(0, 3)
                .join("\\")
            )
          ) {
            let folderLength = folderName.split("\\").length;
            let customPathLength =
              props.fileRestore?.enumFolder?.customPathTemp &&
              decodeHandler(props.fileRestore.enumFolder?.customPathTemp).split(
                "\\"
              ).length;
            let pathLength =
              props.fileRestore?.enumFolder?.path &&
              decodeHandler(props.fileRestore.enumFolder.path).split("\\")
                .length;

            if (
              (props.fileRestore.enumFolder?.customPathTemp &&
                decodeHandler(
                  props.fileRestore.enumFolder.customPathTemp
                ).split("\\")[customPathLength - 1] ===
                  folderName.split("\\")[folderLength - 2]) ||
              (props.fileRestore.enumFolder?.customPathTemp === null &&
                props.fileRestore?.enumFolder?.path &&
                decodeHandler(props.fileRestore.enumFolder.path).split("\\")[
                  pathLength - 1
                ] === folderName.split("\\")[folderLength - 2])
            ) {
              setInvalidRestorePath(prevState =>
                prevState === false ? !prevState : prevState
              );
              break;
            } else {
              setInvalidRestorePath(prevState =>
                prevState === true ? !prevState : prevState
              );
            }
          }
        }
      }
    }
  }, [props.fileRestore.enumFolder]);

  useEffect(() => {
    if (
      props.fileRestore.enumFolder &&
      (props.fileRestore.enumFolder.path === "alldrives" ||
        props.fileRestore.enumFolder.loading)
    ) {
      lMethods.disablePopupConfirm(true);
      lMethods.disableLeftFooter(true, true);
    } else if (invalidRestorePath) {
      lMethods.disablePopupConfirm(true);
      lMethods.disableLeftFooter(false, false);
    } else {
      lMethods.disablePopupConfirm(false);
      lMethods.disableLeftFooter(false, false);
    }

    if (
      props.fileRestore.enumFolder &&
      props.fileRestore.enumFolder.customPathTemp &&
      !invalidRestorePath
    ) {
      lMethods.disablePopupConfirm(false);
    }

    if (
      props.fileRestore.enumFolder &&
      props.fileRestore.enumFolder.createFolderPop
    ) {
      lMethods.disableLeftFooter(false, true);
      document.getElementById("newFolder") &&
        document.getElementById("newFolder").focus();
      document.getElementById("newFolder") &&
        document.getElementById("newFolder").select();
    }
  }, [props.fileRestore.enumFolder, invalidRestorePath]);

  let content = "";

  if (
    props.fileRestore.enumFolder &&
    !props.fileRestore.enumFolder.loading &&
    props.fileRestore.enumFolder.folders.length === 0 &&
    !props.fileRestore.enumFolder.createFolderPop
  )
    content = <EmptyFolder />;
  else if (
    props.fileRestore.enumFolder &&
    !props.fileRestore.enumFolder.loading &&
    props.fileRestore.enumFolder.folders
  )
    content = (
      <div className="fswrap ">
        {props.fileRestore.enumFolder.createFolderPop ? (
          <CreateNewFolder />
        ) : null}
        <div className="fs_body">
          <div className="items_wrap">
            <ul>
              {}
              {props.fileRestore.enumFolder &&
                !props.fileRestore.enumFolder.loading &&
                props.fileRestore.enumFolder.folders.map((folder, i) => (
                  <li key={i}>
                    <div
                      className="item"
                      onClick={() =>
                        props.enumFolder({
                          clientUUID:
                            props.fileRestore.targetMachine.clientUUID,
                          path:
                            props.fileRestore.enumFolder.breadCrumbs.length <= 1
                              ? folder.name
                              : props.fileRestore.enumFolder.breadCrumbs[
                                  props.fileRestore.enumFolder.breadCrumbs
                                    .length - 1
                                ].path +
                                encodeHandler("\\") +
                                folder.name
                        })
                      }
                    >
                      <div className="item_left">
                        <div className="iw_icon">
                          <div
                            className={[
                              "icon",
                              folder.isdrive ? "drive" : "folder"
                            ].join(" ")}
                          >
                            <div className="svg_hard_disk_icon">
                              {" "}
                              {folder.isdrive ? (
                                <HardDiskIcon />
                              ) : (
                                <FolderIcon />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="text">
                          <span>{decodeHandler(folder.name)}</span>
                        </div>
                      </div>
                      <div
                        className="item_right"
                        onClick={e => {
                          e.stopPropagation();
                          props.selectCustomPath(folder.name);
                        }}
                      >
                        <label className="radio_container">
                          <input
                            type="radio"
                            className="input_radio"
                            name="sf_radio"
                            checked={
                              props.fileRestore.enumFolder.customPathTemp ===
                              (props.fileRestore.enumFolder.path === "alldrives"
                                ? ""
                                : props.fileRestore.enumFolder.path +
                                  encodeHandler("\\")) +
                                folder.name
                            }
                          />
                          <span className="radio_checkmark" />{" "}
                        </label>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    );

  return (
    <div className="fspopup_wrap is_relative table_transparent_loader">
      <div className="breadcrumb">
        <BreadCrumbs
          enumFolder={props.fileRestore.enumFolder}
          listEnum={props.enumFolder}
          clientUUID={props.fileRestore.targetMachine.clientUUID}
        />
      </div>
      {content ? (
        content
      ) : (
        <div className="fs_body">
          <div className="items_wrap"></div>
        </div>
      )}
      {props.fileRestore.enumFolder && props.fileRestore.enumFolder.loading ? (
        <TransLoader />
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    fileRestore: state.fileRestore,
    FRTargetMachine: state.fileRestore.targetMachine
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      enumFolder,
      selectCustomPath
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomLocationBody);
